import React from 'react';
import { size } from 'styles';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { TitleSecondary } from '../text';
import Listing from './Listing';
import { ItemColumn } from '../layout';

const Container = styled(ItemColumn)`
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: ${size(5)};
`;

const NoResults = styled(TitleSecondary)`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -66px;
  text-align: center;
`;

const Listings = ({
  className,
  hoverFeature,
  hoveredFeatureId,
  list,
  selectFeature,
  selectedFeatureId,
  unhoverFeature,
}) => (
  <Container className={className} sp={5}>
    {list.length > 0 ? (
      list.map(({ id, title, date }) => (
        <Listing
          date={date}
          id={id}
          isHovered={hoveredFeatureId === id}
          isSelected={selectedFeatureId === id}
          key={id}
          onClick={selectFeature}
          onMouseEnter={hoverFeature}
          onMouseLeave={unhoverFeature}
          title={title}
        />
      ))
    ) : (
      <NoResults>No events found</NoResults>
    )}
  </Container>
);

Listings.propTypes = {
  className: PropTypes.string,
  hoverFeature: PropTypes.func.isRequired,
  hoveredFeatureId: PropTypes.number,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectFeature: PropTypes.func.isRequired,
  selectedFeatureId: PropTypes.number,
  unhoverFeature: PropTypes.func.isRequired,
};

Listings.defaultProps = {
  className: '',
  hoveredFeatureId: null,
  selectedFeatureId: null,
};

export default Listings;
